import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

/** "submitted" thanks the reviewer; "lookupFailed" says the review form couldn't open. */
export type ProductReviewToastKind = "submitted" | "lookupFailed";

export interface ProductReviewToastSliceState {
  toast: ProductReviewToastKind | null;
}

const initialState: ProductReviewToastSliceState = {
  toast: null,
};

export const productReviewToastSlice = createSlice({
  name: "productReviewToastSlice",
  initialState,
  reducers: {
    showProductReviewToast: (state, action: PayloadAction<ProductReviewToastKind>) => {
      state.toast = action.payload;
    },
    hideProductReviewToast: (state) => {
      state.toast = null;
    },
  },
});

export const { showProductReviewToast, hideProductReviewToast } = productReviewToastSlice.actions;
export default productReviewToastSlice;
